// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".errModalContent___D5QMS{font-size:16px;padding:24px 0;line-height:24px}.containerClass___ft2ST{width:464px}\n", "",{"version":3,"sources":["webpack://./src/routes/Reports/routes/NewReport/components/SaveReport/index.css"],"names":[],"mappings":"AAAA,yBACI,cAAA,CADJ,cAAA,CAGI,gBAAA,CAGJ,wBACI,WAAA","sourcesContent":[".errModalContent {\n    font-size: 16px;\n    padding: 24px 0;\n    line-height: 24px;\n}\n\n.containerClass {\n    width: 464px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errModalContent": "errModalContent___D5QMS",
	"containerClass": "containerClass___ft2ST"
};
export default ___CSS_LOADER_EXPORT___;
